import { environment } from '@env';

export const mapOptions: google.maps.MapOptions = {
  restriction: {
    latLngBounds: {
      north: 65,
      south: 35,
      west: -11,
      east: 26,
    },
    strictBounds: true,
  },
  center: {
    lat: environment.mapCenter.lat,
    lng: environment.mapCenter.lng,
  },
  maxZoom: 18,
  minZoom: 5,
  zoom: 6,
  zoomControl: true,
  fullscreenControl: false,
  disableDoubleClickZoom: true,
  disableDefaultUI: true,
  streetViewControl: false,
  gestureHandling: 'greedy',
  scaleControl: false,
  rotateControl: false,
  mapTypeControl: false,
};

export const featureStrokeStyleOptions: google.maps.FeatureStyleOptions = {
  strokeColor: '#d01d74',
  strokeOpacity: 0.5,
  strokeWeight: 1,
  fillColor: 'transparent',
  fillOpacity: 0,
};

export const featureStyleOptions: google.maps.FeatureStyleOptions = {
  strokeColor: '#000000',
  strokeOpacity: 0,
  strokeWeight: 0,
  fillColor: '#304257',
  fillOpacity: 0.2,
};

export const transparentFeatureStyleOptions: google.maps.FeatureStyleOptions = {
  strokeColor: 'transparent',
  strokeOpacity: 0,
  strokeWeight: 0,
  fillColor: 'transparent',
  fillOpacity: 0,
};
